import { useEffect } from "react";

import { useBrowserStateStore } from "../../browserStateStore";
import { useRightPanelStore } from "../../rightPanelStore";

/**
 * Reveal the browser surface when something asked for it out of band.
 *
 * The reveal token is consumed before the surface opens, so this cannot re-fire
 * while the panel is settling. That mattered more when opening meant a
 * navigation; the store applies synchronously, so `previewOpen` is already true
 * on the next render.
 */
export function useBrowserAutoRevealPanel(input: {
  readonly activeThreadKey: string | null;
  readonly previewOpen: boolean;
}): void {
  const { activeThreadKey, previewOpen } = input;
  const pendingAutoRevealKeys = useBrowserStateStore((s) => s.pendingAutoRevealKeys);
  const consumeAutoReveal = useBrowserStateStore((s) => s.consumeAutoReveal);

  useEffect(() => {
    if (!activeThreadKey || previewOpen || !pendingAutoRevealKeys.has(activeThreadKey)) {
      return;
    }
    consumeAutoReveal(activeThreadKey);
    useRightPanelStore.getState().revealBrowser(activeThreadKey);
  }, [activeThreadKey, consumeAutoReveal, pendingAutoRevealKeys, previewOpen]);
}
